import isValidUUID from './isValidUUID';

export default () => {
  const pathname = window.location.pathname;
  const splitPathname = pathname?.split('/');
  const projectsIndex = splitPathname?.indexOf('projects');
  const potentialProjectId =
    projectsIndex >= 0
      ? splitPathname?.[projectsIndex + 1] || undefined
      : undefined;
  return isValidUUID(potentialProjectId) ? potentialProjectId : undefined;
};
